module.exports = __webpack_public_path__ + "static/media/casual-icon.1f6b1f0c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/casual-icon.svg
// module id = 1064
// module chunks = 0